export const ROOMS_COUNT = [
  { value: 'Студия', label: 'Студия' },
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
];

export const REPAIR = [
  { value: 'Без ремонта', label: 'Без ремонта' },
  { value: 'Косметический', label: 'Косметический' },
  { value: 'Евро', label: 'Евро' },
  { value: 'Дизайнерский', label: 'Дизайнерский' },
];

export const FURNITURE = [
  { value: 'Без мебели', label: 'Без мебели' },
  { value: 'На кухне', label: 'На кухне' },
  { value: 'В комнатах', label: 'В комнатах' },
];
